export var ExperimentConfig = {
    RBExperimentProduction: {
        flagKey: 'rb-experiment-production',
        variants: ['control', 'treatment'],
    },
    // DEAP-3695: gates the top "Other designs you might like" (offsite) swimlane on
    // the PDP. Defaults to off (no enrolment) so the swimlane is hidden for everyone;
    // the `control` variant re-shows it (the intact above-the-fold experience).
    OffsiteSimilarDesigns: {
        flagKey: 'rb-offsite-similar-designs-pdp',
        variants: ['control', 'treatment'],
    },
    CartTrayExpressPayments: {
        flagKey: 'rb-cart-tray-express-payments',
        variants: ['control', 'variant'],
    },
    CheckoutHeader: {
        flagKey: 'rb-checkout-header-simplified',
        variants: ['control', 'treatment'],
    },
    CheckoutExpressPaymentsPrioritization: {
        flagKey: 'rb-checkout-express-payments-prioritization',
        variants: ['control', 'treatment'],
    },
    CartTrayCTA: {
        flagKey: 'rb-cart-tray-cta',
        variants: ['control', 'treatment'],
    },
    CartShippingRemoval: {
        flagKey: 'rb-cart-shipping-removal',
        variants: ['control', 'treatment'],
    },
    // DEAP-6061: `treatment` is the original topic-first nav. `default-tshirts` and
    // `dynamic-query` are follow-up arms that change where a topic click lands when
    // no product (canvas) is selected.
    NavTopicsInternal: {
        flagKey: 'rb-nav-topics-internal',
        variants: ['control', 'treatment', 'default-tshirts', 'dynamic-query'],
    },
    SrpStandardPricing: {
        flagKey: 'rb-srp-standard-pricing',
        variants: ['control', 'treatment'],
    },
    PdpMobileColorSwatchVisibility: {
        flagKey: 'rb-pdp-mobile-color-swatch-visibility',
        variants: ['control', 'treatment'],
    },
    FlatLaySRPImage: {
        flagKey: 'rb-flat-lay-srp-image',
        variants: ['control', 'treatment'],
    },
    PdpApparelLeadingImage: {
        flagKey: 'rb-pdp-apparel-leading-image',
        variants: ['control', 'treatment'],
    },
    CartTrustBadgeRemoval: {
        flagKey: 'rb-cart-trust-badge-removal',
        variants: ['control', 'treatment'],
    },
    // DEAP-5003: 4-arm sale banner redesign + countdown duration test.
    // control = current PromoBanner + 24h timer; treatment = new UI for the
    // full sale; treatment-2 = last 48h; treatment-3 = last 72h.
    SaleBannerCountdown: {
        flagKey: 'rb-sale-banner-countdown',
        variants: ['control', 'treatment', 'treatment-2', 'treatment-3'],
    },
};
export var AMPLITUDE_OFF_ENROLMENT = 'off';
